<template>
  <div id="bto-livestream-player" :data-video-only="isOnlyVideo">
    <iframe
      :src="oddinUrl"
      :style="oddinStyle"
      allowfullscreen
      v-if="providerId === STREAM_PROVIDERS.Oddin && oddinUrl">
    </iframe>
    <video class="video-js vjs-big-play-centered" ref="bto-live-player" v-else></video>
  </div>
</template>
<script>
  import { fetchResource } from '../../../services/utils';
  import { STREAM_PROVIDERS } from '../../../models/livestream/livestream.const';
  import GetWebManifestRequestService from './get-web-manifest-request.service';
  import StreamManifestModel from './stream-manifest.model.js';
  import { getIMGArenaStream, getBetradarStream, getStatsPeformStream, getOddinStreamUrl, getSISStream } from '../../../services/livestream/providers';
  import { EVENT_BUS } from '@bto-services/event-bus';

  export default {
    name: 'LivestreamComponent',
    data() {
      return {
        $player: null,
        oddinUrl: '', // stid
        STREAM_PROVIDERS,
      };
    },
    props: {
      streamId: {
        type: String,
        required: true,
      },
      providerId: {
        type: Number,
        default: 3,
      },
      isOnlyVideo: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      oddinStyle() {
        // TODO: Add setting to APP_SETTING if this needs to be set by client
        const style = 'width: 100%; height: 360px;border: none;';
        return style;
      },
    },
    mounted() {
      // If the provider is 7, then we load the iframe
      if (this.providerId === STREAM_PROVIDERS.Oddin) {
        this.oddinUrl = getOddinStreamUrl(this.streamId);
        return;
      }
      const baseUrl = `${APP_SETTINGS.path.baseUrl}/js/videojs/`;
      fetchResource('link', 'bto-videojs-css', { href: `${baseUrl}videojs.css`, rel: 'stylesheet' })
        .then(() => {
          return fetchResource('script', 'bto-videojs-js', { async: true, src: `${baseUrl}videojs.js` });
        })
        .then(this.initPlayer);
    },
    beforeDestroy() {
      if (this.$player) {
        this.$player.dispose();
        this.$player = null;
      }
      const rmgPlayer = document.querySelector("#rmg-player");
      if (rmgPlayer) {
        rmgPlayer.parentNode.removeChild(rmgPlayer);
      }
    },
    methods: {
      initPlayer() {
        if (!APP_SETTINGS.player.token) {
          return;
        }
        // Check this if multiple livestreams are at once on first page load
        if (!window.videojs) {
          EVENT_BUS.once('videojs-loaded', this.initPlayer);
          return;
        }

        EVENT_BUS.emit('videojs-loaded');
        // Init player here so default player isn't shown on load
        this.$player = videojs(this.$refs['bto-live-player'], {
          controls: true,
          autoplay: 'any',
          fluid: true,
          responsive: true,
          liveui: true,
          userActions: {
            hotkeys: true,
          },
        });
        const streamType = this.providerId === 1 ? 3 : 1;
        const streamId = this.providerId === STREAM_PROVIDERS.RMG ? this.$route.params.rmgStreamId : this.streamId
        const getWebManifestService = new GetWebManifestRequestService(streamId, this.providerId, streamType);
        getWebManifestService.execute()
          .then((resp) => new StreamManifestModel(resp.data))
          .then((manifest) => {
            switch (this.providerId) {
              case STREAM_PROVIDERS.Betradar:
                return getBetradarStream(manifest);
              case STREAM_PROVIDERS.Statsperform:
                return getStatsPeformStream(manifest, this.streamId);
              case STREAM_PROVIDERS.IMGArena:
                return getIMGArenaStream(manifest, this.streamId);
              case STREAM_PROVIDERS.SIS:
                return getSISStream(this.streamId, manifest);
              case STREAM_PROVIDERS.RMG:
                return {
                  fixtureId: this.$route.params.matchId.replace("eeid:", ""),
                  streamId: this.$route.params.rmgStreamId,
                  token: manifest.streamUrl,
                };
            }
            return Promise.reject('Invalid provider id');
          })
          .then((resp) => {
            if (this.providerId === STREAM_PROVIDERS.RMG) {
              this.createRmgPlayer(resp);
              return;
            }
            // If errorCode is 0 set source for video player
            // else emit error
            if (resp.errorCode === 0) {
              this.$nextTick(() => {
                // If player is not present return, this happens if we close/change livestream
                if (!this.$player) {
                  return;
                }
                this.$player.src({
                  src: resp.src,
                  type: resp.type,
                });
              });
              return;
            }
            this.handleStreamError(resp.errorMsg || resp.errorCode);
          }).catch(this.handleStreamError);
      },
      handleStreamError() {
        this.$emit('streamLoadError');
      },
      createRmgPlayer(data) {
        const rmgParentElement = document.getElementById("bto-livestream-player");
        rmgParentElement.innerHTML = "";
        const scriptTag = document.createElement("script");
        scriptTag.setAttribute("id", "rmg-player");
        scriptTag.setAttribute("src", "//player.performgroup.com/csb.js");
        scriptTag.setAttribute("data-uuid", data.fixtureId);
        scriptTag.setAttribute("data-outletkey", APP_SETTINGS.lco.rmgOutletKey);
        scriptTag.setAttribute("data-apptype", "csb");
        scriptTag.setAttribute("data-env", "betting");
        scriptTag.setAttribute("data-streamuuid", data.streamId);
        scriptTag.setAttribute("data-streamuser", APP_SETTINGS.player.id);
        scriptTag.setAttribute("data-oauthtoken", data.token);
        scriptTag.setAttribute("data-rmg", "true");
        scriptTag.setAttribute("data-mode", "mini");
        scriptTag.setAttribute("data-width", this.$parent.$el.clientWidth);
        rmgParentElement.appendChild(scriptTag);
      }
    },
  };
</script>
<style scoped>
  div[data-video-only] {
    width: 100%;
  }
</style>